<template>
  <div class="layout-wrapper layout-2">
    <div class="layout-inner">
      <app-layout-sidenav :base-path="`${basePath}/${this.$route.params.portalId}`"  />

      <div class="layout-container">
        <app-layout-navbar />

        <div class="layout-content">
          <div class="router-transitions container-fluid flex-grow-1 container-p-y">
            <router-view :base-path="`${basePath}/${this.$route.params.portalId}`"/>
          </div>

          <app-layout-footer />
        </div>
      </div>
    </div>
    <div class="layout-overlay" @click="closeSidenav"></div>
  </div>
</template>

<script>
import PortalNavbar from './PortalNavbar'
import PortalSidenav from './PortalSidenav'
import PortalFooter from './PortalFooter'

export default {
  name: 'PortalLayout',
  components: {
    'app-layout-navbar': PortalNavbar,
    'app-layout-sidenav': PortalSidenav,
    'app-layout-footer': PortalFooter
  },

  props: {
    basePath: {
      type: String,
      default: ''
    }
  },

  mounted () {
    this.layoutHelpers.init()
    this.layoutHelpers.update()
    this.layoutHelpers.setAutoUpdate(true)
  },

  beforeDestroy () {
    this.layoutHelpers.destroy()
  },

  methods: {
    closeSidenav () {
      this.layoutHelpers.setCollapsed(true)
    }
  },  
}
</script>
